import { useCallback, useEffect, useRef } from 'react';

const DEFAULT_THRESHOLD = 0.5; // only observe when the 50% of the box is in viewthe viewport

export interface UseListObserverProps {
  hasNextPage: boolean;
  onLoadMoreItems: () => void;
  threshold?: number;
}

export const useListObserver = ({
  hasNextPage,
  onLoadMoreItems,
  threshold = DEFAULT_THRESHOLD,
}: UseListObserverProps) => {
  const triggerRef = useRef<HTMLDivElement>(null);

  const handleObserver = useCallback(
    (entries) => {
      if (!entries[0].isIntersecting || !hasNextPage) {
        return;
      }

      onLoadMoreItems();
    },
    [hasNextPage, onLoadMoreItems],
  );

  useEffect(() => {
    if (!triggerRef.current) {
      return;
    }

    const observer = new IntersectionObserver(handleObserver, { threshold });

    observer.observe(triggerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [triggerRef, handleObserver, threshold]);

  return triggerRef;
};
